import { Injectable } from '@angular/core';
import { ClientAccessInviteRequest } from '@interfaces/partners/requests/client-access.request';
import { ClientAccessStatusResponse } from '@interfaces/partners/responses/client-access.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Acesso do cliente (card 3461): o master do parceiro ou o time interno criam o usuário da empresa
 * do deal, que recebe o e-mail de criar senha e assina o termo pela área do cliente.
 *
 * As duas rotas exigem `COMMERCIAL_INVITE_CLIENT`.
 */
@Injectable({
  providedIn: 'root',
})
export class ClientAccessHttpService {
  private readonly BASE_URL = 'partners/deals';

  constructor(private readonly apiService: VaultApiService) {}

  /** Situação do termo e usuários da empresa do deal. */
  getStatus(dealId: string): Observable<ClientAccessStatusResponse | null> {
    return this.apiService.get<ClientAccessStatusResponse>(
      `${this.BASE_URL}/${dealId}/client-access`
    );
  }

  /**
   * Cria o usuário da empresa e manda o e-mail de criar senha. E-mail que já é usuário volta como
   * erro de validação. A resposta é a situação já atualizada.
   */
  invite(
    dealId: string,
    request: ClientAccessInviteRequest
  ): Observable<ClientAccessStatusResponse | null> {
    return this.apiService.post<ClientAccessStatusResponse>(
      `${this.BASE_URL}/${dealId}/client-access`,
      request
    );
  }
}
